import {
    ButtonGroup,
    Card,
    Checkbox,
    Grid,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { debounce } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import TableListToolbar from 'src/components/Table/TableListToolbar';
import Iconify from 'src/components/iconify';
import Label from 'src/components/label';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import CreateScreenModal from 'src/components/modal/CreateScreenModal';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import { DecentralizationListHead } from 'src/sections/@dashboard/decentralization';
import { sendRequest, serviceList } from 'src/utils';
import { KeysPermissions } from 'src/utils/keys';
import crypt from 'src/utils/service/crypt';

const TablePermissionControlGroup = ({ tableData, fuctGet, valueGroupId }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const addFlagsPermission = useRef(false);
    const [permissionFlags, setPermissionFlags] = useState(false);
    const [checked, setChecked] = useState({});

    const screenPermissions = useRef({});
    const user = useRef({});

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        if (userData) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                user.current = data;
            } catch (error) {}
        }
        const menu = sessionStorage.getItem('menu');
        if (menu) {
            try {
                const data = JSON.parse(crypt.deCode(menu));
                // console.log('Loading menu', data[0]);
                screenPermissions.current = data[0].filter((item) => item.screens_key === 'phan_quyen_nguoi_dung')[0];
                // console.log('screenPermissions', screenPermissions);
            } catch (error) {}
        }
    }, []);

    const tableDataHeader = [
        { id: 1, label: t('screen'), alignRight: false },
        { id: 3, label: t('view'), alignRight: false },
        { id: 4, label: t('insert'), alignRight: false },
        { id: 5, label: t('update'), alignRight: false },
        { id: 6, label: t('delete'), alignRight: false },
        { id: 7, label: t('lock'), alignRight: false },
        { id: 8, label: t('import'), alignRight: false },
        { id: 9, label: t('export'), alignRight: false },
    ];

    const handleChange = (event, item, key, key_action) => {
        // console.log("handleChange", item, key)
        const data = {
            ...item,
            // permiss_screen: {
            //     ...item.permiss_screen,
            //     [key]: item.permiss_screen[key] === '0' ? '1' : '0'
            // }
            [key]: item[key] === '1' ? '1' : '1',
        };
        // console.log(data);
        // setChecked(data);
        if (key_action === 'import') {
            key_action = 'import_';
        }
        handlePermission(key_action, data);
    };

    const handlePermission = (key, data) => {
        if (addFlagsPermission.current === true) return;

        // console.log("==============",data, data[KeysPermissions.id]);

        addFlagsPermission.current = true;
        setPermissionFlags(true);
        const InVal = [
            valueGroupId,
            data[KeysPermissions.id],
            key,
            data[KeysPermissions.search],
            data[KeysPermissions.insert],
            data[KeysPermissions.update],
            data[KeysPermissions.delete],
            data[KeysPermissions.block],
            data[KeysPermissions.import],
            data[KeysPermissions.export],
        ];
        // console.log("group id, screen, permiss", InVal)
        sendRequest(serviceList.processGroupPermission, InVal, permissionResult, true, timeOutFunctPermission, 40000);
    };

    const permissionResult = (reqInfoMap, message) => {
        setPermissionFlags(false);
        addFlagsPermission.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log("Success")
            fuctGet && fuctGet(valueGroupId);
        }
    };

    const timeOutFunctPermission = (reqInfo) => {
        setPermissionFlags(false);
        addFlagsPermission.current = false;
        toast.error(t('error.time_out'));
    };

    return (
        <>
            <TableContainer sx={{ paddingTop: 0, paddingBottom: 5, maxHeight: 450, overflow: 'auto' }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {tableDataHeader.map((headCell, index) => (
                                <TableCell key={index}>
                                    <TableHead>{headCell.label}</TableHead>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData.length > 0 ? (
                            tableData.map((item, index) => {
                                return (
                                    <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                        <TableCell component="th" scope="row" padding="5px">
                                            <Typography variant="subtitle2" noWrap>
                                                {t(item[KeysPermissions.screens_key]).toUpperCase()}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                // checked={checked === '1' ? true : false}
                                                checked={item[KeysPermissions.search] === '1' ? true : false}
                                                disabled={
                                                    item[KeysPermissions.work_status] === '0' ||
                                                    item[KeysPermissions.search] === '2' ||
                                                    (user.current?.group_user !== '1' &&
                                                        screenPermissions.current?.search_permission === '1' &&
                                                        screenPermissions.current?.insert_permission !== '1' &&
                                                        screenPermissions.current?.update_permission !== '1')
                                                        ? true
                                                        : false
                                                }
                                                indeterminate={item[KeysPermissions.search] === '2' ? true : false}
                                                onChange={(e) =>
                                                    handleChange(e, item, KeysPermissions.search, 'search')
                                                }
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item[KeysPermissions.insert] === '1' ? true : false}
                                                disabled={
                                                    item[KeysPermissions.work_status] === '0' ||
                                                    item[KeysPermissions.insert] === '2' ||
                                                    (user.current?.group_user !== '1' &&
                                                        screenPermissions.current?.search_permission === '1' &&
                                                        screenPermissions.current?.insert_permission !== '1' &&
                                                        screenPermissions.current?.update_permission !== '1')
                                                        ? true
                                                        : false
                                                }
                                                indeterminate={item[KeysPermissions.insert] === '2' ? true : false}
                                                onChange={(e) =>
                                                    handleChange(e, item, KeysPermissions.insert, 'insert')
                                                }
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item[KeysPermissions.update] === '1' ? true : false}
                                                disabled={
                                                    item[KeysPermissions.work_status] === '0' ||
                                                    item[KeysPermissions.update] === '2' ||
                                                    (user.current?.group_user !== '1' &&
                                                        screenPermissions.current?.search_permission === '1' &&
                                                        screenPermissions.current?.insert_permission !== '1' &&
                                                        screenPermissions.current?.update_permission !== '1')
                                                        ? true
                                                        : false
                                                }
                                                indeterminate={item[KeysPermissions.update] === '2' ? true : false}
                                                onChange={(e) =>
                                                    handleChange(e, item, KeysPermissions.update, 'update')
                                                }
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item[KeysPermissions.delete] === '1' ? true : false}
                                                disabled={
                                                    item[KeysPermissions.work_status] === '0' ||
                                                    item[KeysPermissions.delete] === '2' ||
                                                    (user.current?.group_user !== '1' &&
                                                        screenPermissions.current?.search_permission === '1' &&
                                                        screenPermissions.current?.insert_permission !== '1' &&
                                                        screenPermissions.current?.update_permission !== '1')
                                                        ? true
                                                        : false
                                                }
                                                indeterminate={item[KeysPermissions.delete] === '2' ? true : false}
                                                onChange={(e) =>
                                                    handleChange(e, item, KeysPermissions.delete, 'delete')
                                                }
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item[KeysPermissions.block] === '1' ? true : false}
                                                disabled={
                                                    item[KeysPermissions.work_status] === '0' ||
                                                    item[KeysPermissions.block] === '2' ||
                                                    (user.current?.group_user !== '1' &&
                                                        screenPermissions.current?.search_permission === '1' &&
                                                        screenPermissions.current?.insert_permission !== '1' &&
                                                        screenPermissions.current?.update_permission !== '1')
                                                        ? true
                                                        : false
                                                }
                                                indeterminate={item[KeysPermissions.block] === '2' ? true : false}
                                                onChange={(e) => handleChange(e, item, KeysPermissions.block, 'block')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item[KeysPermissions.import] === '1' ? true : false}
                                                disabled={
                                                    item[KeysPermissions.work_status] === '0' ||
                                                    item[KeysPermissions.import] === '2' ||
                                                    (user.current?.group_user !== '1' &&
                                                        screenPermissions.current?.search_permission === '1' &&
                                                        screenPermissions.current?.insert_permission !== '1' &&
                                                        screenPermissions.current?.update_permission !== '1')
                                                        ? true
                                                        : false
                                                }
                                                indeterminate={item[KeysPermissions.import] === '2' ? true : false}
                                                onChange={(e) =>
                                                    handleChange(e, item, KeysPermissions.import, 'import')
                                                }
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item[KeysPermissions.export] === '1' ? true : false}
                                                disabled={
                                                    item[KeysPermissions.work_status] === '0' ||
                                                    item[KeysPermissions.export] === '2' ||
                                                    (user.current?.group_user !== '1' &&
                                                        screenPermissions.current?.search_permission === '1' &&
                                                        screenPermissions.current?.insert_permission !== '1' &&
                                                        screenPermissions.current?.update_permission !== '1')
                                                        ? true
                                                        : false
                                                }
                                                indeterminate={item[KeysPermissions.export] === '2' ? true : false}
                                                onChange={(e) =>
                                                    handleChange(e, item, KeysPermissions.export, 'export')
                                                }
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        ) : (
                            <></>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default TablePermissionControlGroup;
